import service from "@/utils/request";
import qs from "qs";

export const getGamePass = (data?: any) => {
  return service({
    url: "/GameController/getGamePass",
    method: "GET",
    data: data,
  });
};

export const getGames = (params?: any) => {
  return service({
    url: "/GameController/getGames",
    method: "GET",
    params,
  });
};
export const tipsOperate = (data?: any) => {
  return service({
    url: "/GameController/tipsOperate",
    method: "POST",
    data,
  });
};
export const gamePass = (params?: any) => {
  return service({
    url: "/GameController/gamePass",
    method: "GET",
    params,
  });
};
